// @ts-ignore
import * as uuid from "uuid"
import useAuthStore from "../store/AuthStore"
import useAlertStore from "../store/AlertStore"
import {
    EudRequestDashboards,
    EudResponseDashboards
} from "@ev24/proto-eud-luna-web-api/elwa_v1_pb"
import {EudUserAccountServiceClient} from "@ev24/proto-eud-luna-web-api/elwa_v1_grpc_web_pb"
import type {RpcError} from "grpc-web"
import type {GRPCHeaders, GRPCOptions} from "../interfaces/AuthInterface"

export interface ReportDataResponse {
    count: number
    reportId: string
    requestId: string
    data: any[]
    filters: any
    defs: ReportDefs
}

export interface ReportDefs {
    uiCacheMaxAgeInMinutes?: number
}

export interface ReportFilters {
    offset?: number | null
    limit?: number | null
}


export default class LunaSol {

    private readonly _path: any
    private readonly _options: GRPCOptions
    private readonly _headers: GRPCHeaders

    constructor(path: string, headers: GRPCHeaders = {}, options: GRPCOptions = {}) {
        this._path = path
        this._options = options
        this._headers = headers
    }

    /**
     *  SolService --
     * EsdaUiReportDefService
     * EsdaUiReportDefServiceClient
     *
     * Sol --
     * EsdaUiReportFull
     * EsdaUiReportsFull
     * EudRequestEsdaEsdaUiReportsFull
     * EudResponseEsdaEsdaUiReportsFull
     *
     */

    public async uiReportDef(): Promise<unknown> {
        return new Promise((resolve, reject): void => {
            const alertStore = useAlertStore()
            const authStore = useAuthStore()
            if (!authStore.authInfo.elwa_jwt) {
                alertStore.error("Invalid authentication, please login again");
                reject("Invalid authentication, please login again");
                return;
            }
            const clientService = new EudUserAccountServiceClient(
                this._path,
                {}
            )

            const request: EudRequestDashboards = new EudRequestDashboards()

            request.setToken(authStore.authInfo.elwa_jwt)
            request.setRequestId(uuid.v4())

            /**
             *  getUiDashboards(
             *     request: elwa_v1_pb.EudRequestDashboards,
             *     metadata: grpcWeb.Metadata | undefined,
             *     callback: (err: grpcWeb.RpcError,
             *                response: elwa_v1_pb.EudResponseDashboards) => void
             *   ): grpcWeb.ClientReadableStream<elwa_v1_pb.EudResponseDashboards>;
             */

            clientService.getUiDashboards(
                request,
                this._headers,
                (err: RpcError, response: EudResponseDashboards) => {
                    console.log("getUiDashboards", {response}, {err})
                    if (response) {
                        const responseData = this.responseData(response)
                        if (responseData === null) {
                            reject(err)
                            return
                        }
                        if (responseData.code === "200") {
                            resolve(responseData)
                        } else {
                            alertStore.error(responseData.message)
                            reject(responseData)
                        }
                        return
                    }
                    if (err) {
                        console.error({err})
                        alertStore.error(
                            err.message ||
                            "An Error Occurred: Unable to pull reports at this time."
                        );
                        reject(err)
                        return
                    }
                }
            );
        });
    }


    protected responseData(response: EudResponseDashboards): EudResponseDashboards.AsObject | null {
        try {
            if (response) {
                return response.toObject()
            }
        } catch (e) {
            const alertStore = useAlertStore()
            alertStore.error("500: Server error SS101")
        }
        return null;
    }
}
